/**
 * Models Management Page
 * Module 07 - Dashboard UI
 */

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import ModelsList from '../components/Models/ModelsList';
import UploadModal from '../components/Models/UploadModal';
import Button from '../components/common/Button';

interface ModelsRouterState {
  openUpload?: boolean;
}

const Models: React.FC = () => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const state = location.state as ModelsRouterState | null;
    if (state?.openUpload) {
      setUploadModalOpen(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.pathname, location.state, navigate]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">3D Models</h1>
          <p className="mt-1 text-sm text-gray-500">
            Manage your 3D model library
          </p>
        </div>
        <Button
          onClick={() => setUploadModalOpen(true)}
          className="flex items-center gap-2"
        >
          <Plus className="h-5 w-5" />
          Upload Model
        </Button>
      </div>

      <ModelsList onUploadRequest={() => setUploadModalOpen(true)} />

      <UploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
      />
    </div>
  );
};

export default Models;
